module.exports = __webpack_public_path__ + "img/1f3d4.fc1e8be.svg";